<!--投资机构详情-->
<template>
  <div class="basic-div" :style="'min-height:'+heightH+'px'">
    <header-index/>
    <div class="basic-content">
      <div class="basic-details-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item><a @click="back">企业详情</a></el-breadcrumb-item>
          <el-breadcrumb-item>投资机构详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row class="basic-details" :style="'height:'+heightL+''">
        <el-row>
          <el-col :span="24">
            <div class="demo-basic--circle" style="float: left;padding: 20pt;">
              <div class="block">
                <el-avatar shape="square" :size="150" fit="contain" :src="enterpriseInfo.organizationLogo"></el-avatar>
              </div>
            </div>
            <div class="userName">{{ enterpriseInfo.organizationName }}</div>
            <div style="font-size: 12pt;color: #333333;padding-left: 85pt;margin-top: 10px;">
              <span>成立年份：{{ enterpriseInfo.dateEstablishment }}年</span>
              <span style="padding-left: 40px;">所属地：{{ enterpriseInfo.territory }}</span>
            </div>
            <div class="el-enterprise">
              <span style="color: #999999">简介：</span>{{ enterpriseInfo.briefIntroduction }}
            </div>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="24">
            <el-tabs type="card" v-model="defaultTabs" :stretch="true" @tab-click="handleClick">
              <el-tab-pane label="机构成员" name="first"/>
              <el-tab-pane label="投资事件" name="second"/>
              <el-tab-pane label="基金管理人" name="third"/>
              <el-tab-pane label="管理基金" name="fourth"/>
              <el-tab-pane label="对外投资基金" name="fifth"/>
              <el-tab-pane label="统计分析" name="sixth"/>
              <el-tab-pane label="新闻舆情" name="seventh"/>
            </el-tabs>
            <!--机构成员-->
            <el-row style="margin-top: 20px;" ref="first">
              <el-col :span="24">
                <div class="small-title">机构成员{{ agencyMembers.length }}</div>
                <div class="top-div">
                  <vxe-table resizable border ref="xTable1" :data="agencyMembers" align="left">
                    <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
                    <vxe-column field="name" title="姓名" width="120">
                      <template #default="{ row }">
                        <el-avatar shape="square" :size="40" fit="contain" :src="row.logo" v-if="row.logo"></el-avatar>
                        <el-avatar shape="square" :size="40" fit="contain" v-else>{{row.name.substr(0, 1)}}</el-avatar>
                        <el-link type="primary" :underline="false" class="avatar-title">{{ row.name || '-' }}</el-link>
                      </template>
                    </vxe-column>
                    <vxe-column field="post" title="职位" width="260"></vxe-column>
                    <vxe-column field="briefIntroduction" title="简介"></vxe-column>
                  </vxe-table>
                </div>
              </el-col>
            </el-row>
            <!--投资事件-->
            <el-row style="margin-top: 20px;" ref="second">
              <el-col :span="24">
                <div class="small-title">投资事件{{ investEvent.length }}</div>
                <div class="top-div">
                  <vxe-table resizable border ref="xTable2" :data="investEvent" align="left">
                    <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
                    <vxe-column field="companyInfo" title="产品名称">
                      <template #default="{ row }">
                        <el-avatar shape="square" :size="40" fit="contain" :src="row.project.logo" v-if="row.project.logo"></el-avatar>
                        <el-avatar shape="square" :size="40" fit="contain" v-else>{{ row.project.name.substr(0, 1) }}</el-avatar>
                        <el-link type="primary" :underline="false" class="avatar-title">{{ row.project.name || '-' }}</el-link>
                      </template>
                    </vxe-column>
                    <vxe-column field="belongCompany" title="所属公司">
                      <template #default="{ row }">
                        <el-link :underline="false">{{ row.companyInfo.name || '-' }}</el-link>
                      </template>
                    </vxe-column>
                    <vxe-column field="participationRounds" title="参与轮次" width="90"></vxe-column>
                    <vxe-column field="investmentTime" title="投资时间" width="110"></vxe-column>
                    <vxe-column field="investmentAmount" title="投资金额" width="120"></vxe-column>
                    <vxe-column field="projectIntroduction" title="产品介绍"></vxe-column>
                  </vxe-table>
                </div>
              </el-col>
            </el-row>
            <!--基金管理人-->
            <el-row style="margin-top: 20px;" ref="third">
              <el-col :span="24">
                <div class="small-title">基金管理人{{ fundAdministrator.length }}</div>
                <div class="top-div">
                  <vxe-table resizable border ref="xTable3" :data="fundAdministrator" align="left">
                    <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
                    <vxe-column field="companyName" title="企业名称">
                      <template #default="{ row }">
                        <el-link type="primary" style="color: #0067DD">{{ row.companyName }}</el-link>
                      </template>
                    </vxe-column>
                    <vxe-column field="mname" title="法定代表人">
                      <template #default="{ row }">
                        <el-link type="primary" style="color: #0067DD">{{ row.mname }}</el-link>
                      </template>
                    </vxe-column>
                    <vxe-column field="registeredCapital" title="注册资本"></vxe-column>
                    <vxe-column field="establishTime" title="成立日期"></vxe-column>
                  </vxe-table>
                </div>
              </el-col>
            </el-row>
            <!--管理基金-->
            <el-row style="margin-top: 20px;" ref="fourth">
              <el-col :span="24">
                <div class="small-title">管理基金{{ managedMoney.length }}</div>
                <div class="top-div">
                  <vxe-table resizable border ref="xTable4" :data="managedMoney" align="left">
                    <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
                    <vxe-column field="companyName" title="企业名称">
                      <template #default="{ row }">
                        <el-link type="primary" style="color: #0067DD">{{ row.companyName }}</el-link>
                      </template>
                    </vxe-column>
                    <vxe-column field="mname" title="法定代表人">
                      <template #default="{ row }">
                        <el-link type="primary" v-if="row.mname!='未公开'" style="color: #0067DD">{{ row.mname }}</el-link>
                        <span v-else>{{ row.mname }}</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="registeredCapital" title="注册资本"></vxe-column>
                    <vxe-column field="establishTime" title="成立日期"></vxe-column>
                  </vxe-table>
                </div>
              </el-col>
            </el-row>
            <!--对外投资基金-->
            <el-row style="margin-top: 20px;" ref="fifth">
              <el-col :span="24">
                <div class="small-title">对外投资基金{{ outboundInvestment.length }}</div>
                <div class="top-div">
                  <vxe-table resizable border ref="xTable4" :data="outboundInvestment" align="left">
                    <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
                    <vxe-column field="companyName" title="企业名称">
                      <template #default="{ row }">
                        <el-link type="primary" style="color: #0067DD">{{ row.companyName }}</el-link>
                      </template>
                    </vxe-column>
                    <vxe-column field="name" title="法定代表人">
                      <template #default="{ row }">
                        <el-link type="primary" v-if="row.name!='未公开'" style="color: #0067DD">{{ row.name }}</el-link>
                        <span v-else>{{ row.name }}</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="registeredCapital" title="注册资本" width="200"></vxe-column>
                    <vxe-column field="establishTime" title="成立日期" width="120"></vxe-column>
                    <vxe-column field="investor" title="投资方"></vxe-column>
                  </vxe-table>
                </div>
              </el-col>
            </el-row>
            <!--统计分析-->
            <el-row style="margin-top: 20px;" ref="sixth">
              <el-col :span="24">
                <div class="small-title">统计分析
                  <el-select v-model="searchYear" style="float: right;" @change="onSelectedDrug">
                    <el-option v-for="item in Years" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
              </el-col>
              <!--投资阶段-->
              <el-col :span="11" class="el-cols" style="margin-top: 10px;">
                <div class="small-tit">投资阶段</div>
                <div id="container"/>
              </el-col>
              <!--投资阶段详情-->
              <el-dialog title="投资阶段详情" :visible.sync="Dialog2" width="75%">
                <vxe-table resizable border ref="xTable4" :data="stageDetail" align="left">
                  <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
                  <vxe-column field="project" title="产品名称" width="260">
                    <template #default="{ row }">
                      <el-avatar shape="square" :size="40" fit="contain" :src="row.project.logo" v-if="row.project.logo"></el-avatar>
                      <el-avatar shape="square" :size="40" fit="contain" v-else>{{row.project.name.substr(0, 1)}}</el-avatar>
                      <el-link type="primary" :underline="false" class="avatar-title">{{row.project.name || '-'}}</el-link>
                    </template>
                  </vxe-column>
                  <vxe-column field="participationRounds" title="融资轮次" width="100"></vxe-column>
                  <vxe-column field="investmentTime" title="投资时间" width="120"></vxe-column>
                  <vxe-column field="investmentAmount" title="投资金额" width="120"></vxe-column>
                  <vxe-column field="projectIntroduction" title="产品介绍"></vxe-column>
                </vxe-table>
              </el-dialog>
              <!--投资行业-->
              <el-col :span="11" class="el-cols" style="margin-top: 10px;float: right;margin-right: 30px;">
                <div class="small-tit">投资行业</div>
                <div id="container2" style="padding: 10px;"/>
              </el-col>
              <!--投资行业详情-->
              <el-dialog title="投资行业详情" :visible.sync="Dialog1" width="75%">
                <vxe-table resizable border ref="xTable4" :data="industryDetail" align="left">
                  <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
                  <vxe-column field="project" title="产品名称" width="260">
                    <template #default="{ row }">
                      <el-avatar shape="square" :size="40" fit="contain" :src="row.project.logo" v-if="row.project.logo"></el-avatar>
                      <el-avatar shape="square" :size="40" fit="contain" v-else>{{row.project.name.substr(0, 1)}}</el-avatar>
                      <el-link type="primary" :underline="false" class="avatar-title">{{row.project.name || '-'}}</el-link>
                    </template>
                  </vxe-column>
                  <vxe-column field="participationRounds" title="融资轮次" width="100"></vxe-column>
                  <vxe-column field="investmentTime" title="投资时间" width="120"></vxe-column>
                  <vxe-column field="investmentAmount" title="投资金额" width="120"></vxe-column>
                  <vxe-column field="projectIntroduction" title="产品介绍"></vxe-column>
                </vxe-table>
              </el-dialog>
              <!--投资规模-->
              <el-col :span="11" class="el-cols">
                <div class="small-tit">投资规模</div>
                <div id="container3" style="padding: 10px;"/>
              </el-col>
              <!--投资规模详情-->
              <el-dialog title="投资规模详情" :visible.sync="Dialog3" width="75%">
                <vxe-table resizable border ref="xTable4" :data="scaleDetail" align="left">
                  <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
                  <vxe-column field="project" title="产品名称" width="260">
                    <template #default="{ row }">
                      <el-avatar shape="square" :size="40" fit="contain" :src="row.project.logo" v-if="row.project.logo"></el-avatar>
                      <el-avatar shape="square" :size="40" fit="contain" v-else>{{row.project.name.substr(0, 1)}}</el-avatar>
                      <el-link type="primary" :underline="false" class="avatar-title">{{row.project.name || '-'}}</el-link>
                    </template>
                  </vxe-column>
                  <vxe-column field="participationRounds" title="融资轮次" width="100"></vxe-column>
                  <vxe-column field="investmentTime" title="投资时间" width="120"></vxe-column>
                  <vxe-column field="investmentAmount" title="投资金额" width="120"></vxe-column>
                  <vxe-column field="projectIntroduction" title="产品介绍"></vxe-column>
                </vxe-table>
              </el-dialog>
              <!--投资案例-->
              <el-col :span="11" class="el-cols" style="float: right;margin-right: 30px;">
                <div class="small-tit">投资案例</div>
                <div id="container4" style="padding: 10px;"/>
              </el-col>
              <!--投资案例详情-->
              <el-dialog title="投资案例详情" :visible.sync="Dialog4" width="75%">
                <vxe-table resizable border ref="xTable4" :data="caseDetail" align="left">
                  <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
                  <vxe-column field="project" title="产品名称" width="260">
                    <template #default="{ row }">
                      <el-avatar shape="square" :size="40" fit="contain" :src="row.project.logo" v-if="row.project.logo" style="height: 40px;width: auto;min-width: 40px;margin-right: 10px;float:left;"></el-avatar>
                      <el-avatar shape="square" fit="contain" v-else  style="height: 40px;width: auto;min-width: 40px;margin-right: 10px;float:left;padding: 0 5px">{{row.project.name.substr(0, 1)}}</el-avatar>
                      <el-link type="primary" :underline="false" class="avatar-title">{{row.project.name || '-'}}</el-link>
                    </template>
                  </vxe-column>
                  <vxe-column field="participationRounds" title="融资轮次" width="100"></vxe-column>
                  <vxe-column field="investmentTime" title="投资时间" width="120"></vxe-column>
                  <vxe-column field="investmentAmount" title="投资金额" width="120"></vxe-column>
                  <vxe-column field="projectIntroduction" title="产品介绍"></vxe-column>
                </vxe-table>
              </el-dialog>
            </el-row>
            <!--新闻舆情-->
            <el-row style="margin-top: 20px;" ref="seventh">
              <el-col :span="24">
                <div class="small-title">新闻舆情{{ newPublicOpinion.length }}</div>
                <div class="top-div">
                  <vxe-table resizable border ref="xTable4" :data="newPublicOpinion" align="left">
                    <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
                    <vxe-column field="title" title="新闻">
                      <template #default="{ row }">
                        <el-link type="primary" style="color: #0067DD">{{ row.title }}</el-link>
                      </template>
                    </vxe-column>
                    <vxe-column field="dataSource" title="来源" width="260"></vxe-column>
                    <vxe-column field="time" title="发布日期" width="200"></vxe-column>
                  </vxe-table>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-row>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import {Chart} from '@antv/g2';
import Vue from 'vue'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
import {
  INewAgencyMembersService,
  investmentInstitutionsDetails,
  getNewPublicInvestmentEventList,
  getNewFundManagementList,
  getInvestmentFunds,
  getInvestmentAgencyNewsList,
  getInvestmentStage,
  getInvestmentIndustry,
  getInvestmentScale,
  getInvestmentCase,
  getInvestmentStageDetails,
  getInvestmentIndustryDetails,
  getInvestmentScaleDetails,
  getInvestmentCaseDetails
} from '@/api/enterpriseDetailsApi'
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import HeaderIndex from "@/components/header/headerIndex";
import cityJson from "@/static/cityJson.json";
let chart = "";
let chart2 = '';
let chart3 = '';
let chart4 = '';
Vue.use(VXETable)
export default {
  name: "investmentInstitutions",
  components: {HeaderIndex, Hang, Home_footer},
  data() {
    return {
      id: '',
      cityList:{},
      /*公司id*/
      cid: 0,
      heightH: document.documentElement.clientHeight,
      heightL: 'auto',
      defaultTabs: 'first', searchYear: '2018', Dialog1: false, Dialog2: false, Dialog3: false, Dialog4: false,
      enterpriseInfo: {},
      agencyMembers: [],
      investEvent: [],
      fundAdministrator: [],
      managedMoney: [],
      outboundInvestment: [],
      charts1: [],
      charts2: [],
      charts3: [],
      charts4: [],
      Years: [
        {value: '2018', label: '2018年'},
        {value: '2019', label: '2019年'},
        {value: '2020', label: '2020年'},
        {value: '2021', label: '2021年'},
        {value: '2022', label: '2022年'},
      ],
      newPublicOpinion: [],
      industryDetail: [],
      stageDetail: [],
      scaleDetail: [],
      caseDetail: [],
    }
  },
  methods: {
    /*tabs标签切换*/
    handleClick(tab, event) {
      window.scrollTo(0, this.$refs[tab.name].$el.offsetTop);
    },
    onSelectedDrug(value) {
      this.searchYear = value;
      this.getInvestmentStageInfo();
      this.getInvestmentIndustryInfo();
      this.getInvestmentScaleInfo();
      this.getInvestmentCaseInfo();
    },
    GetPercent(num, total) {
      num = parseFloat(num);
      total = parseFloat(total);
      if (isNaN(num) || isNaN(total)) {
        return "-";
      }
      return total <= 0 ? "0%" : (Math.round(num / total * 10000) / 100.00) + "%";
    },
    /*根据投资机构id获取--机构成员列表*/
    getINewAgencyMembersService() {
      INewAgencyMembersService({id: this.id, request: 'form', page: 1}).then(res => {
        if (res.code == 200) {
          this.agencyMembers = res.content.rows;
        }
      })
    },
    /*获取基本信息*/
    getInvestmentInstitutionsDetails() {
      investmentInstitutionsDetails({id: this.id, request: 'form', page: 1}).then(res => {
        if (res.code == 200) {
          this.enterpriseInfo = res.content;
        }
      })
    },
    /*投资事件*/
    getNewPublicInvestmentEventListInfo() {
      getNewPublicInvestmentEventList({id: this.id, request: 'form', page: 1}).then(res => {
        if (res.code == 200) {
          for (let rows of res.content.rows) {
            if (rows.companyInfo != '' && rows.companyInfo != null && rows.companyInfo != undefined) {
              rows.companyInfo = JSON.parse(rows.companyInfo.replace(/\'/g, '"'));
            }
            if (rows.project != '' && rows.project != null && rows.project != undefined) {
              rows.project = JSON.parse(rows.project.replace(/\'/g, '"'));
            }
          }
          this.investEvent = res.content.rows;
        }
      })
    },
    /*基金管理人/管理基金*/
    getNewFundManagementListInfo() {
      /*基金管理人*/
      getNewFundManagementList({id: this.id, request: 'form', page: 1, type: 1}).then(res => {
        if (res.code == 200) {
          this.fundAdministrator = res.content.rows;
        }
      })
      /*管理基金*/
      getNewFundManagementList({id: this.id, request: 'form', page: 1, type: 2}).then(res => {
        if (res.code == 200) {
          this.managedMoney = res.content.rows;
        }
      })
    },
    /*对外投资基金*/
    getInvestmentFundsInfo() {
      getInvestmentFunds({investmentId: parseInt(this.id), request: 'form', page: 1}).then(res => {
        if (res.code == 200) {
          this.outboundInvestment = res.content.rows;
        }
      })
    },
    /*新闻舆情*/
    getInvestmentAgencyNewsListInfo() {
      getInvestmentAgencyNewsList({mechanism_id: parseInt(this.id), request: 'form', page: 1}).then(res => {
        if (res.code == 200) {
          this.newPublicOpinion = res.content.rows;
        }
      })
    },
    /*统计分析-投资阶段*/
    getInvestmentStageInfo() {
      getInvestmentStage({investmentId: parseInt(this.id), request: 'form', year: this.searchYear}).then(res => {
        if (res.code == 200) {
          this.charts1 = [];
          for (let rows of res.content.length) {
            this.charts1.push({round: rows.name, value: parseInt(rows.num), typeId: rows.typeId});
          }
          this.initCharts();
        }
      })
    },
    initCharts() {
      chart.data(this.charts1);
      chart.scale('value', {nice: true,});
      chart.axis('round', {tickLine: null});
      chart.tooltip({showMarkers: false, enterable: true});
      chart.interaction('active-region');
      chart.interval().position('round*value').size(20).style('round', val => {
        return {fillOpacity: 1, lineWidth: 0, stroke: '#636363'};
      });
      chart.theme({
        "styleSheet": {
          "brandColor": "#0067DD",
          "paletteQualitative10": ["#0067DD"],
          "paletteQualitative20": ["#0067DD"]
        }
      });
      chart.on('element:click', (ev) => {
        this.stageDetails(ev.data.data.typeId);
      });
      chart.render(true)
    },
    /*投资阶段详情*/
    stageDetails(id) {
      getInvestmentStageDetails({mechanism_id: parseInt(this.id), request: 'form', typeId: id, page: 1}).then(res => {
        if (res.code == 200) {
          for (let rows of res.content.rows) {
            if (rows.companyInfo != '' && rows.companyInfo != null && rows.companyInfo != undefined) {
              rows.companyInfo = JSON.parse(rows.companyInfo.replace(/\'/g, '"'))
            }
            if (rows.project != '' && rows.project != null && rows.project != undefined) {
              rows.project = JSON.parse(rows.project.replace(/\'/g, '"'))
            }
          }
          this.stageDetail = res.content.rows;
          this.Dialog2 = true;
        }
      })
    },
    /*统计分析-投资行业*/
    getInvestmentIndustryInfo() {
      getInvestmentIndustry({mechanism_id: parseInt(this.id), request: 'form', year: this.searchYear}).then(res => {
        if (res.code == 200) {
          let sum = 0;
          this.charts2 = [];
          for (let rows of res.content) {
            sum += parseInt(rows.num);
          }
          setTimeout(function () {
            for (let row of res.content) {
              this.charts2.push({
                item: row.investment_industry, count: parseInt(row.num),
                percent: this.GetPercent(parseInt(row.num), sum), typeId: row.typeId
              });
            }
            this.initCharts2();
          }.bind(this), 50)
        }
      })
    },
    initCharts2() {
      chart2.coordinate('theta', {radius: 0.75});
      chart2.data(this.charts2);
      chart2.scale('count', {
        formatter: (val) => {
          return val
        },
      });
      chart2.tooltip({showTitle: false, showMarkers: false, position: "right", follow: false});
      chart2.interval().position('count').color('item').label('count', {
        content: (data) => {
          return `${data.item}`;
        },
      }).adjust('stack');
      chart2.interaction('element-active');
      chart2.on('element:click', (ev) => {
        this.industryDetails(ev.data.data.item);
      });
      chart2.render(true)
    },
    /*投资行业详情*/
    industryDetails(item) {
      getInvestmentIndustryDetails({
        mechanism_id: parseInt(this.id),
        request: 'form',
        investmentIndustry: item,
        page: 1
      }).then(res => {
        if (res.code == 200) {
          for (let rows of res.content.rows) {
            if (rows.companyInfo != '' && rows.companyInfo != null && rows.companyInfo != undefined) {
              rows.companyInfo = JSON.parse(rows.companyInfo.replace(/\'/g, '"'))
            }
            if (rows.project != '' && rows.project != null && rows.project != undefined) {
              rows.project = JSON.parse(rows.project.replace(/\'/g, '"'))
            }
          }
          this.industryDetail = res.content.rows;
          this.Dialog1 = true;
        }
      })
    },
    /*统计分析-投资规模*/
    getInvestmentScaleInfo() {
      this.charts3 = [];
      getInvestmentScale({mechanism_id: parseInt(this.id), request: 'form', year: this.searchYear}).then(res => {
        if (res.code == 200) {
          this.charts3.push({time: '1月', value: parseInt(res.content['01']), month: '01'});
          this.charts3.push({time: '2月', value: parseInt(res.content['02']), month: '02'});
          this.charts3.push({time: '3月', value: parseInt(res.content['03']), month: '03'});
          this.charts3.push({time: '4月', value: parseInt(res.content['04']), month: '04'});
          this.charts3.push({time: '5月', value: parseInt(res.content['05']), month: '05'});
          this.charts3.push({time: '6月', value: parseInt(res.content['06']), month: '06'});
          this.charts3.push({time: '7月', value: parseInt(res.content['07']), month: '07'});
          this.charts3.push({time: '8月', value: parseInt(res.content['08']), month: '08'});
          this.charts3.push({time: '9月', value: parseInt(res.content['09']), month: '09'});
          this.charts3.push({time: '10月', value: parseInt(res.content['10']), month: '10'});
          this.charts3.push({time: '11月', value: parseInt(res.content['11']), month: '11'});
          this.charts3.push({time: '12月', value: parseInt(res.content['12']), month: '12'});
          this.initCharts3();
        }
      })
    },
    initCharts3() {
      chart3.data(this.charts3);
      chart3.scale('value', {nice: true,});
      chart3.axis('time', {tickLine: null});
      chart3.tooltip({showMarkers: false, enterable: true});
      chart3.interaction('active-region');
      chart3.interval().position('time*value').size(20).style('time', val => {
        return {fillOpacity: 1, lineWidth: 0, stroke: '#636363'};
      });
      chart3.on('element:click', (ev) => {
        this.scaleDetails(ev.data.data.month);
      });
      chart3.theme({
        "styleSheet": {
          "brandColor": "#0067DD",
          "paletteQualitative10": ["#0067DD"],
          "paletteQualitative20": ["#0067DD"]
        }
      });
      chart3.render();
    },
    scaleDetails(month) {
      getInvestmentScaleDetails({
        mechanism_id: parseInt(this.id),
        request: 'form',
        yearAndMon: this.searchYear + '-' + month,
        page: 1
      }).then(res => {
        if (res.code == 200) {
          for (let rows of res.content.rows) {
            if (rows.companyInfo != '' && rows.companyInfo != null && rows.companyInfo != undefined) {
              rows.companyInfo = JSON.parse(rows.companyInfo.replace(/\'/g, '"'))
            }
            if (rows.project != '' && rows.project != null && rows.project != undefined) {
              rows.project = JSON.parse(rows.project.replace(/\'/g, '"'))
            }
          }
          this.scaleDetail = res.content.rows;
          this.Dialog3 = true;
        }
      })
    },
    /*统计分析-投资案例*/
    getInvestmentCaseInfo() {
      this.charts4 = [];
      getInvestmentCase({mechanism_id: parseInt(this.id), request: 'form', year: this.searchYear}).then(res => {
        if (res.code == 200) {
          this.charts4.push({time: '1月', value: parseInt(res.content['01']), month: '01'});
          this.charts4.push({time: '2月', value: parseInt(res.content['02']), month: '02'});
          this.charts4.push({time: '3月', value: parseInt(res.content['03']), month: '03'});
          this.charts4.push({time: '4月', value: parseInt(res.content['04']), month: '04'});
          this.charts4.push({time: '5月', value: parseInt(res.content['05']), month: '05'});
          this.charts4.push({time: '6月', value: parseInt(res.content['06']), month: '06'});
          this.charts4.push({time: '7月', value: parseInt(res.content['07']), month: '07'});
          this.charts4.push({time: '8月', value: parseInt(res.content['08']), month: '08'});
          this.charts4.push({time: '9月', value: parseInt(res.content['09']), month: '09'});
          this.charts4.push({time: '10月', value: parseInt(res.content['10']), month: '10'});
          this.charts4.push({time: '11月', value: parseInt(res.content['11']), month: '11'});
          this.charts4.push({time: '12月', value: parseInt(res.content['12']), month: '12'});
          this.initCharts4();
        }
      })
    },
    initCharts4() {
      chart4.data(this.charts4);
      chart4.scale('value', {nice: true,});
      chart4.axis('time', {tickLine: null});
      chart4.tooltip({showMarkers: false, enterable: true});
      chart4.interaction('active-region');
      chart4.interval().position('time*value').size(20).style('time', val => {
        return {fillOpacity: 1, lineWidth: 0, stroke: '#636363'};
      });
      chart4.on('element:click', (ev) => {
        this.caseDetails(ev.data.data.month);
      });
      chart4.theme({
        "styleSheet": {
          "brandColor": "#0067DD",
          "paletteQualitative10": ["#0067DD"],
          "paletteQualitative20": ["#0067DD"]
        }
      });
      chart4.render();
    },
    caseDetails(month) {
      getInvestmentCaseDetails({
        mechanism_id: parseInt(this.id),
        request: 'form',
        yearAndMon: this.searchYear + '-' + month,
        page: 1
      }).then(res => {
        if (res.code == 200) {
          for (let rows of res.content.rows) {
            if (rows.companyInfo != '' && rows.companyInfo != null && rows.companyInfo != undefined) {
              rows.companyInfo = JSON.parse(rows.companyInfo.replace(/\'/g, '"'))
            }
            if (rows.project != '' && rows.project != null && rows.project != undefined) {
              rows.project = JSON.parse(rows.project.replace(/\'/g, '"'))
            }
          }
          this.caseDetail = res.content.rows;
          this.Dialog4 = true;
        }
      })
    },
    back(){
      window.history.back()
    }
  },
  mounted() {
    this.$nextTick(() => {
      chart = new Chart({container: 'container', autoFit: true, height: 300});
      chart2 = new Chart({container: 'container2', autoFit: true, height: 280});
      chart3 = new Chart({container: 'container3', autoFit: true, height: 300});
      chart4 = new Chart({container: 'container4', autoFit: true, height: 300});
    })
    this.getINewAgencyMembersService();
    this.getInvestmentInstitutionsDetails();
    this.getNewPublicInvestmentEventListInfo();
    this.getNewFundManagementListInfo();
    this.getInvestmentFundsInfo();
    this.getInvestmentAgencyNewsListInfo();
    this.getInvestmentStageInfo();
    this.getInvestmentIndustryInfo();
    this.getInvestmentScaleInfo();
    this.getInvestmentCaseInfo();
  },
  beforeMount() {
    this.id = this.$route.query.id;
    this.cid = this.$route.query.cid;
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
  }
}
</script>
<style scoped>
.basic-div >>> .el-avatar > img {
  display: block;
  height: 100%;
  width: 100%;
  vertical-align: middle;
}

.basic-div >>> .el-avatar {
  background: white;
  border: 1px solid #CAD1DA;
  border-radius: 4px;
  color: #333333;
}

.basic-div >>> .el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
  color: #0067DD;
  border-top: 4px solid #0067DD;
}

.basic-div >>> .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #0067DD;
  background-color: #FFF;
  border-top: 4px solid #0067DD;
}

.basic-div >>> .el-tabs--border-card > .el-tabs__header {
  background-color: #FCFCFC;
  border-bottom: none;
  margin: 0;
}

.basic-div >>> .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  border: 1px solid #EEEEEE;
  color: #333333;
  font-size: 15px;
}

.basic-div >>> .vxe-table--render-default .vxe-body--column:not(.col--ellipsis), .vxe-table--render-default .vxe-footer--column:not(.col--ellipsis), .vxe-table--render-default .vxe-header--column:not(.col--ellipsis) {
  padding: 10px 0 !important;
}

.basic-div >>> .vxe-table .vxe-table--header-wrapper {
  color: #333333;
  background: #F3F9FC;
}

.basic-div >>> .vxe-table--render-default {
  color: #333333;
}

.basic-div >>> .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px !important;
  font-weight: 400;
}

.basic-div >>> .el-tabs__item {
  padding: 0 30px !important;
  height: 60px !important;
  line-height: 60px !important;
  font-weight: bold !important;
}
</style>
<style scoped lang="scss">
.basic-div {
  background: #ECEEF5;
  /*头部条样式*/
  .container-header {
    background: #081961;
    padding: 20px 15%;
    color: white;
    font-size: 16px;
    font-weight: bold;
  }

  /*企业基本信息css样式*/
  .basic-content {
    padding: 20px 15% 10px;
    background: #ECEEF5;
    min-width: 76rem;
    .basic-details {
      background: white;
      padding: 30px;
      overflow: auto;
      margin-top: 20px;
    }
    .basic-details::-webkit-scrollbar {
      width: 4px;
    }

    .basic-details::-webkit-scrollbar-thumb {
      height: 8px;
      border-radius: 8px;
      background-color: #999999;
    }
  }
  .avatar-title {
    text-align: left;
    color: #333333;
    line-height: unset;
    margin-top: -30px;
  }
  .top-div {
    padding: 10px 30px 20px;
  }

  .userName {
    font-size: 20pt;
    color: #333333;
    margin-top: 20pt;
    font-weight: bold;
  }

  .small-title {
    padding: 0px 30px 10px;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
  }

  .small-tit {
    padding-bottom: 20px;
    font-size: 14px;
    font-weight: bold;
    color: #333333;
  }

  .el-cols {
    border: 1px solid #D0E0F2;
    margin-top: 20px;
    margin-left: 30px;
    padding: 20px;
  }

  .el-enterprise {
    font-size: 12pt;
    color: rgb(51, 51, 51);
    margin-left: 142pt;
    margin-top: 5px;
    width: 84%;
    line-height: 24px;
    margin-bottom: 20px;
  }
}
</style>